export const publicProfile = [
    {
        url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
        emoji: '🎵',
        nombre: 'Rick Astley - Never Gonna Give You Up (Official Music Video)'
    },
    {
        url: 'https://www.linkedin.com/in/dario-jose-zubaray/',
        emoji: '🛠️',
        nombre: 'LinkedIn'
    },
    {
        url: 'https://dar10comyr.blogspot.com/',
        emoji: '📓',
        nombre: 'Personal Blog'
    },
    {
        url: 'https://github.com/DarioZubaray',
        emoji: '💻',
        nombre: 'Github'
    },
    {
        url: 'https://drive.google.com/file/d/1XCrUatIwcROt_Qz9fFzvpTUi5N8BFODd/view?usp=sharing',
        emoji: '📄',
        nombre: 'CV one page'
    },
    {
        url: 'https://drive.google.com/file/d/1ebJU3xhFCeQDARJeMDd0x--vyFlzzTK2/view?usp=sharing',
        emoji: '📜',
        nombre: 'Full CV'
    }
]